<template>
  <div>
    <vxe-grid
      ref="listingTable"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true }"
      @cell-click="onCellClick"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
      cell-class-name="align-top"
      resizable
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:sellType="{ row }">
        <el-tag
          v-if="row.v_sellType"
          size="mini"
          :type="
            row.sellType === 'B'
              ? ''
              : row.sellType === 'C'
              ? 'warning'
              : 'success'
          "
        >
          {{ row.v_sellType || $l('tag_no_sell_type') || '未配置' }}
        </el-tag>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.storeSkuStatus === 'Y'
              ? 'success'
              : row.storeSkuStatus === 'S' ||
                row.storeSkuStatus === 'B' ||
                row.storeSkuStatus === 'W'
              ? 'danger'
              : row.storeSkuStatus === 'X'
              ? 'warning'
              : ''
          "
        >
          {{
            row.v_storeSkuStatus ||
              $l('tag_no_store_sku_status') ||
              '未配置状态'
          }}
        </el-tag>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <span>SKU：</span><span style="color: #303133">{{ row.evgSkuNo }}</span>
        <br />
        <span>{{ row.brandName }}</span>
        <br />
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>

        <div v-if="'Y' == row.isCombine" class="mt-2">
          <el-tag type="warning" size="mini" effect="plain">
            {{ $l('table_label_isCombine') || '组合产品' }}
          </el-tag>
        </div>
      </template>
      <template v-slot:displayFactory="{ row }">
        <div v-if="row.ncNo">
          <span>NC：{{ row.ncNo }}</span>
        </div>
        <span>{{ row.scmName }}</span>
      </template>
      <template v-slot:displaySalesTitle="{ row }">
        <span>{{ row.salesTitle }}</span>
        <br />
        <span>{{ $l('table_cell_channelItemNo') || '渠道Item号' }}：</span>
        <span style="color: #409EFF">{{ row.channelItemNo }}</span>
        <br />
        <span>{{ $l('table_cell_channelSkuNo') || '渠道款号' }}：</span>
        <span style="color: #409EFF">{{ row.channelSkuNo }}</span>
        <br />
        <span>{{ $l('table_cell_channelEanNo') || '渠道条码号' }}：</span>
        <span style="color: #409EFF">{{ row.channelEanNo }}</span>
        <br />
        <span>{{ $l('table_cell_eachGtinNo') || '渠道产品GTIN号' }}：</span>
        <span style="color: #409EFF">{{ row.eachGtinNo }}</span>
        <br />
        <span
          >{{ $l('table_cell_innerPackGtinNo') || '渠道内包装GTIN号' }}：</span
        >
        <span style="color: #409EFF">{{ row.innerPackGtinNo }}</span>
        <br />
        <span>{{ $l('table_cell_caseGtinNo') || '渠道箱包装GTIN号' }}：</span>
        <span style="color: #409EFF">{{ row.caseGtinNo }}</span>
      </template>
      <template v-slot:displayPlatformName="{ row }">
        <span>{{ $l('table_cell_channel_name') || '渠道名称' }}：</span
        ><span style="color: #303133">{{ row.platformName }}</span>
        <br />
        <span>BRAND：</span
        ><span style="color: #303133">{{ row.platformBrandName }}</span>
        <br />
        <span>{{ $l('table_cell_sale_platform') || '销售渠道' }}：</span
        ><span style="color: #303133">{{ row.v_platformType }}</span>
        <br />
        <div>
          <span>METHOD：</span>
          <el-tag
            v-if="row.v_evgSellType"
            size="mini"
            :type="
              row.evgSellType === 'B'
                ? ''
                : row.evgSellType === 'C'
                ? 'warning'
                : 'success'
            "
          >
            {{ row.v_evgSellType || $l('tag_no_evg_sell_type') || '未配置' }}
          </el-tag>
        </div>
        <div>
          <span>STATUS：</span>
          <el-tag
            size="mini"
            :type="
              row.evgSkuPlatformStatus === 'Y'
                ? 'success'
                : row.evgSkuPlatformStatus === 'S' ||
                  row.evgSkuPlatformStatus === 'B' ||
                  row.evgSkuPlatformStatus === 'W'
                ? 'danger'
                : row.evgSkuPlatformStatus === 'X'
                ? 'warning'
                : ''
            "
          >
            {{ row.v_evgSkuPlatformStatus || '未配置状态' }}
          </el-tag>
        </div>
      </template>
      <template v-slot:warehouse="{ row }">
        <span>{{ $l('table_cell_ecomWarehouseCode') || '发货仓库' }}：</span>
        <span style="color: #409EFF">{{ row.ecomWarehouseCodeText }}</span>
        <br />
        <span>{{ $l('table_cell_whSkuNo') || '仓库SKU号' }}：</span>
        <span style="color: #409EFF">{{ row.whSkuNo }}</span>
        <br />
        <span>{{ $l('table_cell_sellableEach') || '最小出货' }}：</span>
        <span style="color: #409EFF"
          >{{ row.sellableEachQty }} {{ row.sellableEachUnitText }}</span
        >
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                icon="el-icon-edit"
                :command="{
                  pageType: 'edit',
                  platformCode: row.platformCode,
                  evgSkuPlatformCode: row.evgSkuPlatformCode,
                }"
                :disabled="!allow('M')"
              >
                {{ $l('btn_edit_product') || '编辑产品' }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    onCheckboxChange({ records }) {
      this.$emit('checkboxChange', records)
    },
    // 避免点击操作列也会选择行
    onCellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'defaultImageUrl', 'col-opt']
      if (filterColumns.includes(property)) return

      const $listingTable = this.$refs.listingTable
      $listingTable.toggleCheckboxRow(row)
      const data = $listingTable.getCheckboxRecords(true)
      this.$emit('checkboxChange', data)
    },
    handleCommand({ platformCode, evgSkuPlatformCode }) {
      this.$emit('showDetail', { platformCode, evgSkuPlatformCode })
    },
  },
}
</script>
